import HttpService from '../http/http.service';
import {
    GroupChatsViewModel,
    GroupChatViewModel,
    UpdateGroupChatNameRequest,
    KickGroupChatMemberRequest,
    GenericViewModel,
    ChatSearchViewModel,
    CreateGroupChatRequest,
    UpdateGroupChatImageRequest,
    ChatMessageViewModel
} from '@/types/apiServerContract';

const API_PATH = 'chat/';

export class ChatApi {
    public static async CreateGroupChat(request: CreateGroupChatRequest): Promise<GroupChatViewModel> {
        return HttpService.Post<GroupChatViewModel>(API_PATH + 'CreateGroupChat', request);
    }

    public static async GetOrCreateGroupChat(memberGuid: string): Promise<GroupChatViewModel> {
        return HttpService.Get<GroupChatViewModel>(API_PATH + 'GetOrCreateGroupChat', {
            memberGuid
        });
    }

    public static async GetGroupChats(): Promise<GroupChatsViewModel> {
        return HttpService.Get<GroupChatsViewModel>(API_PATH + 'GetGroupChats');
    }

    public static async GetMessagesForChat(chatId: string, page: number, requestedMessageId?: string | null): Promise<ChatMessageViewModel> {
        return HttpService.Get<ChatMessageViewModel>(API_PATH + 'GetMessagesForChat', {
            chatId,
            page,
            requestedMessageId
        });
    }

    public static async MarkMessagesAsRead(chatId: string): Promise<GenericViewModel<number>> {
        return HttpService.Get<GenericViewModel<number>>(API_PATH + 'MarkMessagesAsRead', {
            chatId
        });
    }

    public static async LeaveGroupChat(chatId: string): Promise<GenericViewModel<boolean>> {
        return HttpService.Get<GenericViewModel<boolean>>(API_PATH + 'LeaveGroupChat', {
            chatId
        });
    }

    public static async UpdateGroupChatName(request: UpdateGroupChatNameRequest): Promise<GroupChatViewModel> {
        return HttpService.Post<GroupChatViewModel>(API_PATH + 'UpdateGroupChatName', request);
    }

    public static async UpdateGroupChatImage(request: UpdateGroupChatImageRequest): Promise<GroupChatViewModel> {
        return HttpService.Post<GroupChatViewModel>(API_PATH + 'UpdateGroupChatImage', request);
    }

    public static async KickMember(request: KickGroupChatMemberRequest): Promise<GenericViewModel<boolean>> {
        return HttpService.Post<GenericViewModel<boolean>>(API_PATH + 'KickMember', request);
    }

    public static async Search(term: string): Promise<ChatSearchViewModel> {
        return HttpService.Get<ChatSearchViewModel>(API_PATH + 'Search', {
            term
        });
    }
}
